import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AdminStatsGrid } from "@/components/admin/AdminStatsGrid";
import { AdminUsersTable } from "@/components/admin/AdminUsersTable";
import { AdminTickets } from "@/components/admin/AdminTickets";

const TABS = [
    { id: "overview", label: "Overview" },
    { id: "users", label: "Users" },
    { id: "tickets", label: "Tickets" },
];

export default function Admin() {
    const { user } = useAuth();
    const [tab, setTab] = useState("overview");

    if (user && user.role !== "admin") return <Navigate to="/console" replace />;

    return (
        <div className="max-w-6xl" data-testid="admin-page">
            <div className="mb-8">
                <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-blaze">/ Admin</div>
                <h1 className="font-display font-bold uppercase text-3xl mt-2 tracking-tight">Control Tower</h1>
            </div>

            <div className="flex gap-2 mb-8 flex-wrap" data-testid="admin-tabs">
                {TABS.map((t) => (
                    <button
                        key={t.id}
                        onClick={() => setTab(t.id)}
                        className={`px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.25em] border transition-colors ${
                            tab === t.id
                                ? "border-blaze text-blaze bg-blaze/10"
                                : "border-white/15 text-white/50 hover:text-white hover:border-white/40"
                        }`}
                        data-testid={`admin-tab-${t.id}`}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            {tab === "overview" && <AdminStatsGrid />}
            {tab === "users" && <AdminUsersTable />}
            {tab === "tickets" && <AdminTickets />}
        </div>
    );
}
